import { render, staticRenderFns } from "./CallRecordsQccEcicomplement.vue?vue&type=template&id=4b83e889&scoped=true&"
import script from "./CallRecordsQccEcicomplement.vue?vue&type=script&lang=js&"
export * from "./CallRecordsQccEcicomplement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b83e889",
  null
  
)

component.options.__file = "CallRecordsQccEcicomplement.vue"
export default component.exports